// extracted by mini-css-extract-plugin
module.exports = {"loadScreen":"LoadScreen_loadScreen__205wC","spinner":"LoadScreen_spinner__1OhqZ","load":"LoadScreen_load__1aSvt"};